import IconButton from 'emerald-ui/lib/IconButton';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: IconButton, componentName: 'IconButton' }], 'IconButton'),
  description: 'The IconButton is a Material-like button which label is exclusively an Icon.',
  codeSamples: [
    {
      title: 'Default',
      scope: { IconButton },
      whiteBackground: true,
      code: `<IconButton ariaLabel="Settings" icon="settings" title="Settings" />`,
    },
  ],
};
